import { useState, useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ArrowUp } from 'lucide-react';

export function ScrollToTop() {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const toggleVisibility = () => {
      if (window.pageYOffset > 500) {
        setIsVisible(true);
      } else {
        setIsVisible(false);
      }
    };

    window.addEventListener('scroll', toggleVisibility);
    return () => window.removeEventListener('scroll', toggleVisibility);
  }, []);

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth',
    });
  };

  return (
    <AnimatePresence>
      {isVisible && (
        <motion.button
          initial={{ opacity: 0, scale: 0.5, y: 20 }}
          animate={{ opacity: 1, scale: 1, y: 0 }}
          exit={{ opacity: 0, scale: 0.5, y: 20 }}
          onClick={scrollToTop}
          style={{
            position: 'fixed',
            bottom: '30px',
            right: '30px',
            zIndex: 100,
            width: '48px',
            height: '48px',
            background: 'rgba(13, 27, 42, 0.8)',
            border: '1px solid var(--color-teal)',
            color: 'var(--color-teal)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            cursor: 'pointer',
            backdropFilter: 'blur(10px)',
            clipPath: 'polygon(10px 0, 100% 0, 100% calc(100% - 10px), calc(100% - 10px) 100%, 0 100%, 0 10px)',
            boxShadow: '0 0 20px rgba(62, 143, 166, 0.3)',
            transition: 'all 0.3s ease',
          }}
          whileHover={{ 
            scale: 1.1, 
            background: 'var(--color-teal)', 
            color: 'var(--color-navy)',
            boxShadow: '0 0 30px rgba(62, 143, 166, 0.6)'
          }}
          whileTap={{ scale: 0.9 }}
        >
          <ArrowUp size={24} strokeWidth={2.5} />
          
          {/* HUD decorative corners */}
          <div style={{
            position: 'absolute',
            inset: '4px',
            border: '1px solid rgba(62, 143, 166, 0.2)',
            pointerEvents: 'none',
            clipPath: 'inherit'
          }} />
        </motion.button>
      )}
    </AnimatePresence>
  );
}
